import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { API } from "@/lib/site";

export const TrendingStories = ({ exclude }) => {
  const [data, setData] = useState(null);
  useEffect(() => { fetch(`${API}/news/trending?limit=7`).then((r) => r.json()).then(setData).catch(() => {}); }, []);
  const items = (data?.items || []).filter((i) => i.slug !== exclude).slice(0, 6);
  if (items.length < 3) return null;
  return (
    <section data-testid="trending-stories" className="rounded-xl border border-slate-800 bg-[#121722] p-5 space-y-4">
      <h2 className="flex items-center gap-2 font-display font-semibold">
        <Flame className="h-4 w-4 text-orange-400" /> Most read {data.window}
      </h2>
      <ol className="space-y-3">
        {items.map((s, i) => (
          <li key={s.slug} className="flex gap-3">
            <span className="font-display text-xl font-bold text-slate-600 w-5 shrink-0">{i + 1}</span>
            <Link to={`/news/${s.slug}`} data-testid={`trending-story-${i}`} className="group min-w-0">
              <span className="block text-sm font-semibold leading-snug text-slate-200 group-hover:text-white">{s.title}</span>
              <span className="font-mono text-[10px] uppercase tracking-wider text-sky-400">{s.source}</span>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
};
